declare const normalizedNameBrand: unique symbol;

export type NormalizedName = string & {
  readonly [normalizedNameBrand]: true;
};

// Non-whitespace controls (`\p{Cc}` minus `\t\n\v\f\r`) plus every
// format character (`\p{Cf}`: zero-width joiners, bidi marks, BOM,
// soft hyphen, tag chars, etc.). Whitespace controls survive this
// step so the trim/collapse below can fold them into normal spaces.
// `v` flag enables set subtraction (ES2024).
const INVISIBLE = /[[\p{Cc}\p{Cf}]--[\t\n\v\f\r]]/gv;

export function normalizeName(raw: string): NormalizedName {
  return raw
    .normalize("NFC")
    .replace(INVISIBLE, "")
    .trim()
    .replace(/\s+/g, " ") as NormalizedName;
}

export function namesMatch(a: string, b: string): boolean {
  return normalizeName(a).toLowerCase() === normalizeName(b).toLowerCase();
}
